import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import Header from '../component/include/Header';
import { useForm } from "react-hook-form";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BASE_PATH } from '../constants/Global';
import { useSelector, useDispatch } from 'react-redux';
import DataService from "../services/tutorial.service";
import { logUser } from "../actions/index";
import PhoneInput, { formatPhoneNumber, formatPhoneNumberIntl } from 'react-phone-number-input'

// import {useNavigate } from "react-router-dom";
import { getDatabase, ref, remove, onValue, set, off, update } from "firebase/database";

import { loadCaptchaEnginge, LoadCanvasTemplate, LoadCanvasTemplateNoReload, validateCaptcha } from 'react-simple-captcha';

function Registration() {
    const dispatch = useDispatch();
    const { register, handleSubmit, formState: { errors } } = useForm();
    const isjoin = useSelector((state) => state.isjoin);

    const [isDisabled, setDisabled] = useState(false);
    const history = useHistory({ forceRefresh: true });
    const loginuser = useSelector((state) => state.setUserlog);
    const [mobvalue, setmobValue] = useState("")
    const [countrynum, setcountrynum] = useState('+91')

    //  const navigate = useNavigate();
    if (loginuser != "") {
        history.push(BASE_PATH + 'dashboard');
    }

    const handleCountrychange = () => {
        const phoneInput = document.querySelector('.PhoneInputInput');
        const phoneValue = phoneInput ? phoneInput.value : '';
        setcountrynum(phoneValue); // Logs the value of the input field
      };    

    const onSubmit = (values) => {
        console.log("inside reg cond")

        let user_captcha = document.getElementById('user_captcha_input').value;

        if (validateCaptcha(user_captcha) == false) {
            toast.error("Captcha Does Not Match", { theme: "colored", position: "bottom-center" });
            document.getElementById('user_captcha_input').value = "";
            return false
        }

        setDisabled(true);
        // var mobileformat = formatPhoneNumberIntl(mobvalue)
        // let parts = mobileformat.split(' ');

        // // Extract country code and phone number
        // let countryCode = parts[0];
        // let phoneNumber = parts.slice(1).join('')
        // console.log(countryCode)
        // console.log(phoneNumber)
                let phoneNumber = mobvalue

        if (phoneNumber == "") {
            toast.error("Mobile Number is required !!", {
                theme: "colored",
                position: "bottom-center",
            });
            setDisabled(false);

            return 0
        }
        else if (phoneNumber.length < 7) {
            toast.error("At least 8 digit number !!", {
                theme: "colored",
                position: "bottom-center",
            });
            setDisabled(false);

            return 0
        }
        else if (phoneNumber.length > 12) {
            toast.error("Max limit is 13 digit number !!", {
                theme: "colored",
                position: "bottom-center",
            });
            setDisabled(false);

            return 0
        }
        const id = toast.loading("Please wait...");
        let toastContainerId = toast.update(id, { render: "please wait...", theme: "dark", position: "bottom-center" })

        const HEADER = {
            headers: {
                "Content-Type": "application/json",
                "Cache-Control": "no-cache"
            }
        }
        values['mobno'] = phoneNumber
        values['ccode'] = countrynum
        console.log("values")
        console.log(values)
        DataService.regUser(values, HEADER)
            .then(res => {

                let response = res.data;
                toast.dismiss(toastContainerId);
                console.log("reg response")
                console.log(response)

                if (response.success == true) {
                    const db = getDatabase();
                    const currentTime = new Date().toISOString();

                    set(ref(db, 'auction/info/admin_notifications/registration'), { 'time': currentTime, 'detail': values })
                    var emptyArray = JSON.stringify(new Array(response.data));
                    console.log(emptyArray)
                    localStorage.setItem("user", emptyArray);
                    dispatch(logUser(response.data));
                    window.localStorage.setItem("tkn", response.data.token)

                    toast.success(response.msg, { theme: "dark", position: "bottom-center" });
                    if (isjoin !== "") {
                        history.push(BASE_PATH + "join-auction-code");
            
                      }
                      else{

                          history.push(BASE_PATH + "Dashboard");
                      }
                    // navigate('dashboard')
                    // history.push('dashboard')
                    //  history.push(BASE_PATH+'dashboard');  
                } else {
                    toast.error(response.msg, { theme: "colored", position: "bottom-center" });
                }

                setDisabled(false);
            }).catch(() => {
                console.log('Not valid')
                toast.dismiss(toastContainerId);
                toast.error('Not valid Server Error', { theme: "colored", position: "bottom-center" });
                setDisabled(false);
            })
    }


    useEffect(() => {
        window.scrollTo(0, 0)
        loadCaptchaEnginge(6, 'white', 'black');
    }, [])

    return (
        <>

            {/* <Header/> */}
            <div className="login-area default-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6 col-md-offset-3">
                            <form onSubmit={handleSubmit(onSubmit)} action="" autoComplete="off" id="login-form" className="white-popup-block regfrm" encType="multipart/form-data">

                                <div className="row">
                                    <div className='col-md-12'>
                                        <h4> Registration!</h4>
                                    </div>


                                    <div className="col-12 col-md-6">
                                        <div className="form-group mymar">
                                            <input className="form-control" placeholder="Name" type="text"
                                                {...register("cperson", { required: true, required: 'required field.' })}
                                            />
                                            {errors.cperson && <p className="text-error">{errors.cperson.message}</p>}
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="form-group mymar">
                                            <input className="form-control" placeholder="City" type="text"
                                                {...register("city", { required: true, required: 'required field.' })}
                                            />
                                            {errors.pass && <p className="text-error">{errors.pass.message}</p>}
                                        </div>
                                    </div>

                                    <div className="col-12 col-md-6">
                                        <div className="form-group mymar phonediv">
                                            <PhoneInput
                                                international
                                                initialValueFormat="international"
                                                withCountryCallingCode={false}

                                                defaultCountry="IN"
                                                countryCallingCodeEditable={false}
                                                // value={mobvalu/e}
                                                onChange={
                                                    (v) => { handleCountrychange() }}

                                                minLength={8}
                                                limitMaxLength={13}


                                            />
                                            <span className="text-gray-500">{countrynum}</span>
                                            <input
                                                onChange={(e) => setmobValue(e.target.value)}
                                                value={mobvalue}
                                                type="text"
                                                placeholder="Enter mobile number"
                                                className="ml-2"
                                                style={{ width: '100%' }}
                                            />
                                            {errors.mobno && (
                                                <p className="text-error">{errors.mobno.message}</p>
                                            )}
                                            {/* <input maxLength={10} minLength={10} className="form-control" placeholder="Mobile No" type="number"
                                onInput={(e) => {e.target.value = Math.max( 0, parseInt(e.target.value)).toString().slice(0, 10);}}
                                {...register("mobno", { required: true, maxLength: 10,
                                    required: 'required field.',
                                    maxLength: {
                                        value: 10,
                                        message: 'at-least 10 characters.'
                                      },
                                    minLength: {
                                        value: 10,
                                        message: 'at-least 10 characters.'
                                      } })}  
                                />
                                {errors.mobno && <p className="text-error">{errors.mobno.message}</p>} */}
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-6">
                                        <div className="form-group mymar">
                                            <input className="form-control" placeholder="Password" type="password"
                                                {...register("password", { required: true, required: 'required field.' })}
                                            />
                                            {errors.pass && <p className="text-error">{errors.pass.message}</p>}
                                        </div>
                                    </div>

                                    <div className="col-12 col-md-12">
                                        <div className="form-group mymar">
                                            <input className="form-control" placeholder="Email" type="email"

                                                {...register("email", {
                                                    required: true, required: 'required field.',
                                                    pattern: {
                                                        value: /\S+@\S+\.\S+/,
                                                        message: "not match email format"
                                                    }
                                                })} />

                                            {errors.emailid && <p className="text-error">{errors.emailid.message}</p>}

                                        </div>
                                    </div>






                                    <div className="row margin-0">
                                        <div className="col-md-4 captcha" style={{ textAlign: 'center' }}>
                                            <LoadCanvasTemplate reloadText="Reload  Captcha" reloadColor="#002147" />
                                        </div>


                                        <div className="col-md-8 cpcha">
                                            <div><input placeholder=" Enter Captcha Value"
                                                {...register("user_captcha_input", { required: true, required: 'required field.' })}
                                                id="user_captcha_input" type="text" style={{ width: '100%' }}></input></div>
                                            {errors.user_captcha_input && <p className="text-error">{errors.user_captcha_input.message}</p>}
                                        </div>
                                    </div>


                                    <div className="col-md-12" style={{ marginTop: 15 }}>
                                        <div className="row">

                                            <div className="col-md-4 regsubmbtn">
                                                <button type="submit">
                                                    Submit
                                                </button>
                                            </div>

                                            <div className="col-md-8 align-right regbdiv">
                                                <p className="link-bottom regb"> Already Registered?{" "} <Link to="/"> Login</Link></p>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Registration